/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Load_BookInputs */

const en_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load book`)
};

const es_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar el libro`)
};

const fr_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du chargement du livre`)
};

const de_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden des Buches`)
};

const ja_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本の読み込みに失敗しました`)
};

const zh_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法加载电子书`)
};

const ar_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل في تحميل الكتاب`)
};

const id_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal memuat buku`)
};

const it_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare il libro`)
};

const ru_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить книгу`)
};

const pt_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao carregar o livro`)
};

const ko_failed_to_load_book = /** @type {(inputs: Failed_To_Load_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`책을 불러오지 못했습니다`)
};

/**
* | output |
* | --- |
* | "Failed to load book" |
*
* @param {Failed_To_Load_BookInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const failed_to_load_book = /** @type {((inputs?: Failed_To_Load_BookInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Load_BookInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failed_to_load_book(inputs)
	if (locale === "es") return es_failed_to_load_book(inputs)
	if (locale === "fr") return fr_failed_to_load_book(inputs)
	if (locale === "de") return de_failed_to_load_book(inputs)
	if (locale === "ja") return ja_failed_to_load_book(inputs)
	if (locale === "zh") return zh_failed_to_load_book(inputs)
	if (locale === "ar") return ar_failed_to_load_book(inputs)
	if (locale === "id") return id_failed_to_load_book(inputs)
	if (locale === "it") return it_failed_to_load_book(inputs)
	if (locale === "ru") return ru_failed_to_load_book(inputs)
	if (locale === "pt") return pt_failed_to_load_book(inputs)
	return ko_failed_to_load_book(inputs)
});